import React from 'react'
import { useIsMobile } from 'utils/hooks/useIsMobile'

// eslint-disable-next-line @typescript-eslint/ban-types
const withMobile = <T extends {}>({
  DesktopComponent,
  MobileComponent,
}: {
  DesktopComponent: React.ComponentType<T>
  MobileComponent: React.ComponentType<T>
}) => {
  return (props: T) => {
    const isMobile = useIsMobile()

    if (isMobile) return <MobileComponent {...props} />

    return <DesktopComponent {...props} />
  }
}

export default withMobile
